import { ReactNode } from "react";

import { Navigate } from "react-router-dom";

import { useAccount } from "../../../hooks/useAccount";

export type TPremiumGuardProps = {
	children: ReactNode;
};

export function PremiumGuard({ children }: TPremiumGuardProps) {
	const { account } = useAccount();

	if (!account) {
		return null;
	}

	if (!account.isMember) {
		return <Navigate to="/memberships" replace />;
	}

	return <>{children}</>;
}
